/** @jsxImportSource @emotion/react */
import { createStyles } from '@quickbit/qb-design-system';

interface MerchantLogoProps {
  logoUrl: string;
}
export const MerchantLogo = ({ logoUrl }: MerchantLogoProps) => {
  const styles = useStyles();
  return (
    <div css={styles.merchantLogoContainer}>
      <img src={logoUrl} css={styles.merchantLogoImg} aria-hidden="true" />
    </div>
  );
};

const useStyles = createStyles(({ palette }) => ({
  merchantLogoContainer: {
    border: `1px solid ${palette.grey.x100}`,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '96px',
    height: '96px',
    alignSelf: 'center',
  },
  merchantLogoImg: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
    borderRadius: '50%',
  },
}));
